import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuthContext } from '@/features/auth/context/AuthContext';

export const ProtectedRoute = () => {
  const { isAuthenticated, user } = useAuthContext();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Dok korisnik mora promijeniti lozinku, backend blokira (403) sve osim
  // change-password/logout/refresh — ovdje ga preusmjeravamo na taj ekran
  // umjesto da ostatak aplikacije tiho puca na 403.
  if (user?.mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  return <Outlet />;
};
